module.exports = __webpack_public_path__ + "../resources/images/unlink-0252afe04a804dc65e1d737569bb953d.svg";